import React, { useEffect } from "react";
import { THEME } from "./theme";

function setVar(name, value) {
  document.documentElement.style.setProperty(name, value);
}

export default function ThemeVars() {
  useEffect(() => {
    // tokens básicos usados pelo shell.css
    setVar("--bg", THEME.bg);
    setVar("--panel", THEME.panel);
    setVar("--panel2", THEME.panel2);
    setVar("--border", THEME.border);
    setVar("--text", THEME.text);
    setVar("--muted", THEME.muted);
    setVar("--shadow", THEME.shadow);
    setVar("--r", `${THEME.radius}px`);
    setVar("--rPill", `${THEME.radiusPill}px`);
    setVar("--font", THEME.fontFamily);

    // (opcional) brand/status pra usar no CSS quando quiser
    setVar("--brand", THEME.brand);
    setVar("--brandAccent", THEME.brandAccent);
    setVar("--ok", THEME.ok);
    setVar("--warn", THEME.warn);
    setVar("--alert", THEME.alert);
  }, []);

  return null;
}
